module.exports = __webpack_public_path__ + "img/66600.b9a8d151.jpg";